import type { IssuedInfo } from './otaTypes';

import { tx } from '../../lib/adminI18n';
// URL発行結果パネル（表示のみ）。
//   3画面で同一だったマークアップを共通化。表示の出し分けは元のロジックを完全踏襲する:
//     ・固定URL/アップロードURL 行（常時）
//     ・予約番号 行（issued.code があるOTAのみ）
//     ・チェックイン日（issued.checkin があるとき）
//     ・自社予約の即時救済（!isOta && rescue）: URL直渡し案内 + 閉じる
//     ・自社予約の通常（!isOta && !rescue）: メール文面プレビュー + 送信
//     ・OTA（isOta）: コピーして連絡する旨の案内
//   メール関連ハンドラ(onEditSubject/onEditText/onSendMail)と sending は、
//   メール送信を行う画面（パスポート/チェックイン）だけが渡す。OTA専用画面(予約管理)は
//   issued.isOta=true のため該当分岐が描画されず、未指定でも安全。
interface Props {
  issued: IssuedInfo;
  copiedUrl: string;
  onCopy: (text: string) => void;
  onClose: () => void;
  onEditSubject?: (v: string) => void;
  onEditText?: (v: string) => void;
  onSendMail?: (reservationId: string) => void;
  sending?: boolean;
}

export default function IssuedUrlPanel({
  issued, copiedUrl, onCopy, onClose, onEditSubject, onEditText, onSendMail, sending,
}: Props) {
  return (
    <div style={{ background: '#f0fdf4', border: '1px solid #bbf7d0', borderRadius: 8, padding: '1rem', display: 'grid', gap: '.6rem' }}>
      <div style={{ display: 'flex', gap: '.5rem', alignItems: 'center' }}>
        <span style={{ minWidth: 110, fontSize: '.85rem', color: '#374151' }}>{issued.isOta ? tx('iss.0') : tx('iss.1')}</span>
        <input readOnly value={issued.url} className="pp-input" style={{ flex: 1 }} onFocus={(e) => e.currentTarget.select()} />
        <button type="button" className="pp-btn-sm" onClick={() => onCopy(issued.url)}>{copiedUrl === issued.url ? tx('iss.2') : tx('iss.3')}</button>
      </div>
      {issued.codeUrl && (
        <div style={{ display: 'flex', gap: '.5rem', alignItems: 'center' }}>
          <span style={{ minWidth: 110, fontSize: '.85rem', color: '#374151' }}>{tx('iss.4')}</span>
          <input readOnly value={issued.codeUrl} className="pp-input" style={{ flex: 1 }} onFocus={(e) => e.currentTarget.select()} />
          <button type="button" className="pp-btn-sm" onClick={() => onCopy(issued.codeUrl!)}>{copiedUrl === issued.codeUrl ? tx('iss.2') : tx('iss.3')}</button>
        </div>
      )}
      {issued.code && (
        <div style={{ display: 'flex', gap: '.5rem', alignItems: 'center' }}>
          <span style={{ minWidth: 110, fontSize: '.85rem', color: '#374151' }}>{tx('iss.5')}</span>
          <input readOnly value={issued.code} className="pp-input" style={{ flex: 1, fontWeight: 700, letterSpacing: '.1em' }} onFocus={(e) => e.currentTarget.select()} />
          <button type="button" className="pp-btn-sm" onClick={() => onCopy(issued.code!)}>{copiedUrl === issued.code ? tx('iss.2') : tx('iss.3')}</button>
        </div>
      )}
      {issued.checkin && (
        <div style={{ fontSize: '.85rem', color: '#374151' }}>{tx('iss.6')} <strong>{issued.checkin}</strong></div>
      )}

      {/* 自社予約（即時救済）: メールは送らず、URLを直接渡す案内 */}
      {!issued.isOta && issued.rescue && (
        <div style={{ fontSize: '.8rem', color: '#6b7280', marginTop: '.2rem', borderTop: '1px solid #bbf7d0', paddingTop: '.6rem' }}>
          {tx('iss.7')}
          <div style={{ marginTop: '.5rem', textAlign: 'right' }}>
            <button type="button" className="pp-btn-ghost" onClick={onClose}>{tx('iss.8')}</button>
          </div>
        </div>
      )}

      {/* 自社予約（通常）: メール文面プレビュー + 送信ボタン */}
      {!issued.isOta && !issued.rescue && (
        <div style={{ display: 'grid', gap: '.4rem', marginTop: '.4rem', borderTop: '1px solid #bbf7d0', paddingTop: '.6rem' }}>
          <div style={{ fontSize: '.85rem', color: '#374151' }}>{tx('iss.9')} <strong>{issued.mailTo || '—'}</strong></div>
          <label className="pp-label" style={{ fontSize: '.8rem' }}>{tx('iss.10')}
            <input className="pp-input" value={issued.mailSubject || ''}
              onChange={(e) => onEditSubject?.(e.target.value)} />
          </label>
          <label className="pp-label" style={{ fontSize: '.8rem' }}>{tx('iss.11')}
            <textarea value={issued.mailText || ''} className="pp-input"
              onChange={(e) => onEditText?.(e.target.value)}
              style={{ width: '100%', minHeight: 180, fontFamily: 'inherit', fontSize: '.85rem', lineHeight: 1.6, resize: 'vertical' }} />
          </label>
          <div style={{ display: 'flex', gap: '.5rem', justifyContent: 'flex-end', alignItems: 'center' }}>
            <span style={{ fontSize: '.8rem', color: '#6b7280' }}>{tx('iss.12')}</span>
            <button type="button" className="pp-btn-ghost" onClick={onClose} disabled={sending}>{tx('iss.8')}</button>
            <button type="button" className="pp-btn" onClick={() => onSendMail?.(issued.reservationId)} disabled={sending}>{sending ? tx('iss.13') : tx('iss.14')}</button>
          </div>
        </div>
      )}

      {/* OTA: 送信は不要。コピーして連絡する旨の案内 */}
      {issued.isOta && (
        <div style={{ fontSize: '.8rem', color: '#6b7280', marginTop: '.2rem' }}>
          {tx('iss.15')}
        </div>
      )}
    </div>
  );
}
